// extracted by mini-css-extract-plugin
export var cartContainer = "_p5-4";
export var gray = "_p5-1";
export var itemContainer = "_p5-2";
export var itemDetails = "_p5-3";
export var strong = "_p5-0";